import l from "./TripleBounce.vue2.js";
import { openBlock as r, createElementBlock as t, createElementVNode as n, normalizeStyle as o } from "vue";
/* empty css                  */
import c from "../../../_virtual/_plugin-vue_export-helper.js";
const s = { class: "ap-spinner-triple-bounce" };
function p(e, i, u, a, m, b) {
  return r(), t("div", s, [
    n("div", {
      class: "ap-spinner-triple-bounce-bounce1",
      style: o(e.bounceStyle)
    }, null, 4),
    n("div", {
      class: "ap-spinner-triple-bounce-bounce2",
      style: o(e.bounceStyle)
    }, null, 4),
    n("div", {
      class: "ap-spinner-triple-bounce-bounce3",
      style: o(e.bounceStyle)
    }, null, 4)
  ]);
}
const v = /* @__PURE__ */ c(l, [["render", p]]);
export {
  v as default
};
